module.exports = __webpack_public_path__ + "img/products-shelflife.5a79020c.png";